import { CategorySupportComponent } from "./main-sections/category-support/category-support.component";
import { FastLoginComponent } from "./account/fast-login/fast-login.component";
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { WishlistComponent } from "./account/wishlist/wishlist.component";
import { CartComponent } from "./account/cart/cart.component";
import { DashboardComponent } from "./account/dashboard/dashboard.component";
import { OrderComponent } from "./account/order/order.component";
import { LoginComponent } from "./account/login/login.component";
import { RegisterComponent } from "./account/register/register.component";
import { ForgetPasswordComponent } from "./account/forget-password/forget-password.component";
import { ProfileComponent } from "./account/profile/profile.component";
import { ContactComponent } from "./account/contact/contact.component";
import { CheckoutComponent } from "./account/checkout/checkout.component";
import { AboutUsComponent } from "./about-us/about-us.component";
import { PageComponent } from "./page/page.component";
import { SearchComponent } from "./search/search.component";
import { TypographyComponent } from "./typography/typography.component";
import { ReviewComponent } from "./review/review.component";
import { OrderSuccessComponent } from "./order-success/order-success.component";
import { CompareOneComponent } from "./compare/compare-one/compare-one.component";
import { CompareTwoComponent } from "./compare/compare-two/compare-two.component";
import { CollectionComponent } from "./collection/collection.component";
import { LookbookComponent } from "./lookbook/lookbook.component";
import { ErrorComponent } from "./error/error.component";
import { ComingSoonComponent } from "./coming-soon/coming-soon.component";
import { FaqComponent } from "./faq/faq.component";
import { BlogLeftSidebarComponent } from "./blog/blog-left-sidebar/blog-left-sidebar.component";
import { BlogRightSidebarComponent } from "./blog/blog-right-sidebar/blog-right-sidebar.component";
import { BlogNoSidebarComponent } from "./blog/blog-no-sidebar/blog-no-sidebar.component";
import { BlogDetailsComponent } from "./blog/blog-details/blog-details.component";
import { GridTwoComponent } from "./portfolio/grid-two/grid-two.component";
import { GridThreeComponent } from "./portfolio/grid-three/grid-three.component";
import { GridFourComponent } from "./portfolio/grid-four/grid-four.component";
import { MasonryGridTwoComponent } from "./portfolio/masonry-grid-two/masonry-grid-two.component";
import { MasonryGridThreeComponent } from "./portfolio/masonry-grid-three/masonry-grid-three.component";
import { MasonryGridFourComponent } from "./portfolio/masonry-grid-four/masonry-grid-four.component";
import { MasonryFullWidthComponent } from "./portfolio/masonry-full-width/masonry-full-width.component";
import { MyOrdersComponent } from "./account/my-orders/my-orders.component";
import { NotificationsComponent } from "./account/notifications/notifications.component";
import { NotificationComponent } from "./account/notification/notification.component";
import { MyCouponesComponent } from "./account/my-coupones/my-coupones.component";
import { BrowseLogComponent } from "./account/browse-log/browse-log.component";
import { ArticlesComponent } from "./main-sections/articles/articles.component";
import { OrderStateComponent } from "./account/order-state/order-state.component";
import { AuthGuard } from "../guards/auth.guard";

const routes: Routes = [
  {
    path: "wishlist",
    component: WishlistComponent,
  },
  {
    path: "my-coupones",
    component: MyCouponesComponent,
  },
  {
    path: "browse-log",
    component: BrowseLogComponent,
  },
  {
    path: "my-orders",
    component: MyOrdersComponent,
  },
  {
    path: "notifications",
    component: NotificationsComponent,
  },
  {
    path: "cart",
    component: CartComponent,
  },
  {
    path: "dashboard",
    component: DashboardComponent,
  },
  {
    path: "order/:id",
    component: OrderComponent,
  },
  {
    // canActivate: [AuthGuard],
    path: "order-state/:id",
    component: OrderStateComponent,
  },
  {
    path: "notification/:id",
    component: NotificationComponent,
  },
  {
    path: "login",
    component: FastLoginComponent,
  },
  {
    path: "register",
    component: RegisterComponent,
  },
  {
    path: "forget/password",
    component: ForgetPasswordComponent,
  },
  {
    path: "profile",
    component: ProfileComponent,
  },
  {
    path: "contact",
    component: ContactComponent,
  },
  {
    path: "checkout",
    component: CheckoutComponent,
  },
  {
    path: "aboutus",
    component: AboutUsComponent,
  },
  {
    path: "page/:id/:name",
    component: PageComponent,
  },
  {
    path: "search",
    component: SearchComponent,
  },
  {
    path: "search/:search",
    component: SearchComponent,
  },
  {
    path: "search/:mode/:search",
    component: SearchComponent,
  },
  // !
  {
    path: "formshapes/:search",
    component: SearchComponent,
  },
  {
    path: "key_words/:search",
    component: SearchComponent,
  },
  {
    path: "suggesstion/:search",
    component: SearchComponent,
  },
  //
  {
    path: "order/success",
    component: OrderSuccessComponent,
  },
  {
    path: "category-support/:id/:name",
    component: CategorySupportComponent,
  },
  {
    path: "support-category-page/:category/:id/:name",
    component: ArticlesComponent,
  },
  // {
  //   path: "support-category-page/article/:id/:name",
  //   component: ArticlesComponent,
  // },

  {
    path: "404",
    component: ErrorComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {}
